<script setup lang="ts">
interface Props {
  /** The title of the payment method */
  title: string
  /** The logo component to display */
  logo: string
}

defineProps<Props>()
</script>

<template>
  <section class="payment-card">
    <header class="payment-card__header">
      <component
        :is="logo"
        :alt="title"
        class="payment-card__logo"
      />
      <span class="payment-card__title">{{ title }}</span>
    </header>
    <div class="payment-card__content">
      <slot />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.payment-card {
  --card-bg: rgba(255, 255, 255, 0.05);
  --card-border: transparent;
  --card-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  --card-shadow-hover: 0 4px 12px rgba(0, 0, 0, 0.12);
  --card-transform: translateY(-2px);

  position: relative;
  flex: 1;
  min-width: 200px;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: var(--card-shadow);
  transition: all 0.2s ease;
  overflow: hidden;

  &:hover {
    transform: var(--card-transform);
    box-shadow: var(--card-shadow-hover);
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }

  &__logo {
    height: 32px;
    width: auto;
    border-radius: 6px;
    object-fit: contain;
  }

  &__title {
    font-size: 1.2rem;
    font-weight: 600;
    color: inherit;
  }

  &__content {
    position: relative;
  }
}
</style>
